import { STATES } from '../../../../../constants';
import { selectors } from '../../../../../state';

export function ForwardMailMilitaryConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_FORWARD_MAIL_MILITARY, {
    url: '/military',
    views: {
      '@': {
        template: '<upd-forward-mail-military></upd-forward-mail-military>',
      },
    },
    scrollTop: true,
    title: 'Military Address',
    analytics: {
      page: 'Military',
    },
    data: {
      permissions: 'signedIn && military',
    },
    titleBar: {
      title: 'Forward Your Mail',
      save: 'Average Time Saved: 20 minutes',
    },
  });
}
